import { createStore } from 'satcheljs';

type GreenRoomStore = {
    showGreenRoom: number;
    greenRoomHeight: number;
};
const greenRoomStoreData: GreenRoomStore = {
    showGreenRoom: 1,
    greenRoomHeight: 125,
};

export const getGreenRoomStore = createStore<GreenRoomStore>('greenRoom', greenRoomStoreData);
